export default {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 200,
      ellipsis: true,
      fixed: 'left',
    },

    {
      title: '昵称',
      dataIndex: 'nickname',
      width: 150,
      ellipsis: true,
    },
    {
      title: '电话',
      dataIndex: 'phone',
      ellipsis: true,
      width: 120,
    },
    // {
    //   title: '省份',
    //   dataIndex: 'province',
    //   width: 150,
    //   ellipsis: true,
    // },
    // {
    //   title: '城市',
    //   dataIndex: 'city',
    //   width: 150,
    //   ellipsis: true,
    // },
    {
      title: '留联系人',
      dataIndex: 'linkMan',
      width: 150,
      ellipsis: true,
    },
    {
      title: '留联系电话',
      dataIndex: 'linkTel',
      width: 150,
      ellipsis: true,
    },
  /*  {
      title: '用户标签',
      dataIndex: 'userType',
      width: 150,
      ellipsis: true,
    },*/
    {
      title: '反馈内容',
      dataIndex: 'content',
      width: 180,
      ellipsis: true,
    },
    {
      title: '回复内容',
      dataIndex: 'replyContent',
      width: 180,
      ellipsis: true,
    },
    {
      title: '反馈时间',
      dataIndex: 'createdTime',
      width: 180,
      itemType: 'dateTime',
      ellipsis: true,
    },
    {
      title: '回复时间',
      dataIndex: 'replyDate',
      itemType: 'dateTime',
      width: 180,
      ellipsis: true,
    },
    {
      title: '响应时长',
      dataIndex: 'responseTime',
      width: 180,
      ellipsis: true,
    },
    {
      title: '处理人',
      dataIndex: 'replyUserName',
      width: 180,
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 200,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'nickname',
      label: '昵称',
    },
    {
      name: 'phone',
      label: '电话',
    },
    {
      name: 'linkTel',
      label: '留联系电话',
    },
 /*   {
      name: 'userType',
      label: '用户标签',
      itemType: 'select',
      data: 'userTypeData',
      labelKey: 'label',
      key: 'code',
      allowClear: true,
    },*/
    {
      name: 'createdTime',
      label: '反馈时间',
      itemType: 'autoDate',
      showTime: 'true',
      allowClear: 'true',
    },
  ],
  footer: false,
};
